import checks from "./checks/index.js";
import getSingle from "./get-single.js";
import getAll from "./get-all.js";
import getSingleFallback from "./get-single-fallback.js";

export default {
	checks,
	getSingle,
	getAll,
	getSingleFallback,
};
